// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__uWFtG","container":"styles_container__PGevH","toggleInteraction":"styles_toggleInteraction__V50X5","icon":"styles_icon__40b__"};